export type ErrorType =
  | 'login-ongeldige-hoedanigheid'
  | 'TOTAL_FILE_SIZE_EXCEEDED'
  | 'login-inactief-profiel'
  | 'login-ongeldige-biometrics-token';
